"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../api");
var empTagApi = _interopRequireWildcard(require("@/api/empTagApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var getDefaultStaffForm = function getDefaultStaffForm() {
  return {
    companyId: '',
    workUnit: '',
    empNo: '',
    empName: '',
    phone: '',
    wechat: '',
    dept: '',
    title: '',
    tagId: []
  };
};
var _default2 = exports.default = {
  props: {
    companyOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      title: '新增员工',
      rules: {
        empName: [{
          required: true,
          message: '请输入员工姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入员工手机号',
          trigger: 'blur'
        }],
        companyId: [{
          required: true,
          message: '请选择单位',
          trigger: 'change'
        }]
      },
      form: getDefaultStaffForm(),
      par: {},
      tagOptions: [],
      tagLoading: false,
      tagSelectKey: 0,
      tagSearchTimer: null,
      tagRequestId: 0
    };
  },
  methods: {
    getDefaultForm: function getDefaultForm() {
      return getDefaultStaffForm();
    },
    normalizeTagId: function normalizeTagId(value) {
      var numId = Number(value);
      return Number.isNaN(numId) ? value : numId;
    },
    normalizeTagOptions: function normalizeTagOptions() {
      var _this = this;
      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var source = Array.isArray(list) ? list : list && list.list || list && list.data || [];
      return source.map(function (item) {
        return {
          tagId: _this.normalizeTagId(item.tagId != null ? item.tagId : item.id),
          tagName: item.tagName || item.name || ''
        };
      }).filter(function (item) {
        return item.tagId !== '' && item.tagId !== null && item.tagId !== undefined && item.tagName;
      });
    },
    buildSelectedTagOptions: function buildSelectedTagOptions() {
      var _this2 = this;
      var tagIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var tagNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var ids = Array.isArray(tagIds) ? tagIds : [];
      var names = String(tagNames || '').split(/[,，]/).map(function (name) {
        return name.trim();
      });
      return ids.map(function (id, index) {
        return {
          tagId: _this2.normalizeTagId(id),
          tagName: names[index] || "\u6807\u7B7E".concat(id)
        };
      }).filter(function (item) {
        return item.tagId !== '' && item.tagId !== null && item.tagId !== undefined;
      });
    },
    mergeTagOptions: function mergeTagOptions() {
      var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var merged = [].concat(_toConsumableArray(selectedOptions), _toConsumableArray(this.normalizeTagOptions(newOptions)));
      var map = new Map();
      merged.forEach(function (item) {
        map.set(String(item.tagId), item);
      });
      this.tagOptions = Array.from(map.values());
    },
    parseFormTagIds: function parseFormTagIds(tagId) {
      var _this3 = this;
      if (!tagId) return [];
      if (Array.isArray(tagId)) {
        return tagId.map(function (id) {
          return _this3.normalizeTagId(id);
        }).filter(function (id) {
          return id !== '' && id !== null && id !== undefined;
        });
      }
      if (typeof tagId === 'string') {
        return tagId.split(',').map(function (id) {
          return _this3.normalizeTagId(id.trim());
        }).filter(function (id) {
          return id !== '' && id !== null && id !== undefined;
        });
      }
      return [this.normalizeTagId(tagId)];
    },
    loadTagList: function loadTagList() {
      var _this4 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var requestId = ++this.tagRequestId;
      this.tagLoading = true;
      empTagApi.getTagAutocomplete(keyword).then(function (res) {
        if (requestId !== _this4.tagRequestId) return;
        _this4.mergeTagOptions(res, selectedOptions);
      }).catch(function () {
        if (requestId !== _this4.tagRequestId) return;
        _this4.mergeTagOptions([], selectedOptions);
      }).finally(function () {
        if (requestId === _this4.tagRequestId) {
          _this4.tagLoading = false;
        }
      });
    },
    handleTagSearch: function handleTagSearch(keyword) {
      var _this5 = this;
      if (this.tagSearchTimer) {
        clearTimeout(this.tagSearchTimer);
      }
      this.tagSearchTimer = setTimeout(function () {
        var selectedOptions = _this5.buildSelectedTagOptions(_this5.form.tagId);
        _this5.loadTagList(keyword, selectedOptions);
      }, 300);
    },
    open: function open(data, row) {
      this.tagSelectKey += 1;
      this.par = _objectSpread({}, data);
      if (row) {
        this.form = _objectSpread(_objectSpread({}, row), {}, {
          tagId: this.parseFormTagIds(row.tagId)
        });
        this.handleCompanyChange(this.form.companyId);
        this.title = '编辑员工';
        var selectedOptions = this.buildSelectedTagOptions(this.form.tagId, row.tagName);
        this.loadTagList('', selectedOptions);
      } else {
        this.form = this.getDefaultForm();
        this.title = '新增员工';
        this.tagOptions = [];
        this.loadTagList('');
      }
      this.dialogFormVisible = true;
    },
    close: function close() {
      if (this.tagSearchTimer) {
        clearTimeout(this.tagSearchTimer);
        this.tagSearchTimer = null;
      }
      this.tagRequestId += 1;
      this.form = this.getDefaultForm();
      this.tagOptions = [];
      this.dialogFormVisible = false;
    },
    handleCompanyChange: function handleCompanyChange(val) {
      var target = this.companyOptions.find(function (item) {
        return (item.id || item.value || item.companyId) === val;
      });
      this.form.workUnit = target ? target.name || target.label || target.companyName || '' : '';
    },
    submit: function submit() {
      var _this6 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var params;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (valid) {
                  params = _objectSpread(_objectSpread({}, _this6.form), {}, {
                    customerIntegralId: Number(_this6.par.id)
                  }); // 将 tagId 数组转换为逗号分隔的字符串
                  if (Array.isArray(params.tagId) && params.tagId.length > 0) {
                    params.tagId = params.tagId.join(',');
                  } else if (Array.isArray(params.tagId) && params.tagId.length === 0) {
                    params.tagId = '';
                  }
                  if (_this6.form.id) {
                    _this6.request(_api.updateApi, params, '编辑成功');
                  } else {
                    // 后端改为批量接口，单条也按 List 传递
                    _this6.request(_api.addApi, [params], '新增成功');
                  }
                }
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(api, params, mes) {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return api(params);
            case 1:
              this.$message.success(mes);
              this.$emit('refresh');
              this.close();
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function request(_x2, _x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }
};